import React, { useState } from 'react';
import { Loader2, Edit2, Check, X } from 'lucide-react';
import { semanticBrandingService } from '../../services/semanticBranding';
interface InitialStepProps {
  documentId: string;
  marca: string;
  url: string;
  onUpdate: (marca: string, url: string) => void;
  onNextStep: () => void;
}
const InitialStep: React.FC<InitialStepProps> = ({
  documentId,
  marca,
  url,
  onUpdate,
  onNextStep
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [newMarca, setNewMarca] = useState(marca);
  const [newUrl, setNewUrl] = useState(url);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const handleSave = async () => {
    setIsLoading(true);
    setError('');
    try {
      const response = await semanticBrandingService.updateBrandInfo(documentId, newMarca, newUrl);
      onUpdate(response.brandDocument.marca, response.brandDocument.url);
      setIsEditing(false);
    } catch (error) {
      console.error('Failed to update brand info:', error);
      setError(error.response?.data?.message || 'Erro ao atualizar informações da marca.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleCancel = () => {
    setNewMarca(marca);
    setNewUrl(url);
    setIsEditing(false);
    setError('');
  };
  const handleContinue = () => {
    onNextStep();
  };
  return <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100" data-id="element-1129">
      <h2 className="text-xl font-semibold mb-6 text-gray-900" data-id="element-1130">
        Informações da Marca
      </h2>
      {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md" data-id="element-1131">
          {error}
        </div>}
      <div className="space-y-4" data-id="element-1132">
        {isEditing ? <>
            <div data-id="element-1133">
              <label htmlFor="marca" className="block mb-1 text-sm font-medium text-gray-900" data-id="element-1134">
                Nome da marca
              </label>
              <input type="text" id="marca" value={newMarca} onChange={e => setNewMarca(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" disabled={isLoading} data-id="element-1135" />
            </div>
            <div data-id="element-1136">
              <label htmlFor="url" className="block mb-1 text-sm font-medium text-gray-900" data-id="element-1137">
                URL do site
              </label>
              <input type="url" id="url" name="url" value={newUrl} onChange={e => setNewUrl(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" disabled={isLoading} autoComplete="off" data-id="element-1138" />
            </div>
            <div className="flex space-x-2 mt-4" data-id="element-1139">
              <button onClick={handleSave} className="px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 flex items-center" disabled={isLoading} data-id="element-1140">
                {isLoading ? <Loader2 size={16} className="mr-2 animate-spin" data-id="element-1141" /> : <Check size={16} className="mr-2" data-id="element-1142" />}
                Salvar
              </button>
              <button onClick={handleCancel} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center" disabled={isLoading} data-id="element-1143">
                <X size={16} className="mr-2" data-id="element-1144" />
                Cancelar
              </button>
            </div>
          </> : <div className="space-y-4" data-id="element-1145">
            <div className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-1146">
              <div data-id="element-1147">
                <p className="text-sm text-gray-700" data-id="element-1148">Nome da marca</p>
                <p className="font-medium text-gray-900" data-id="element-1149">{marca}</p>
              </div>
              <button onClick={() => setIsEditing(true)} className="p-2 text-gray-500 hover:text-[#1649ff] hover:bg-gray-50 rounded-full" data-id="element-1150">
                <Edit2 size={16} data-id="element-1151" />
              </button>
            </div>
            <div className="flex justify-between items-center pb-2 border-b border-gray-100" data-id="element-1152">
              <div data-id="element-1153">
                <p className="text-sm text-gray-700" data-id="element-1154">URL do site</p>
                <p className="font-medium text-gray-900" data-id="element-1155">{url}</p>
              </div>
            </div>
            <button onClick={handleContinue} className="w-full mt-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700" data-id="element-1156">
              Continuar para Concorrentes
            </button>
          </div>}
      </div>
    </div>;
};
export default InitialStep;